export const USER_LOGIN_REQUEST = " USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";

export const GET_USER_CONVERSATION_START = "GET_USER_CONVERSATION_START";
export const GET_USER_CONVERSATION_SUCCESS = "GET_USER_CONVERSATION_SUCCESS";
export const GET_USER_CONVERSATION_FAIL = "GET_USER_CONVERSATION_FAIL";

export const DELETE_CONVERSATION_START = "DELETE_CONVERSATION_START";
export const DELETE_CONVERSATION_SUCCESS = "DELETE_CONVERSATION_SUCCESS";
export const DELETE_CONVERSATION_FAIL = "DELETE_CONVERSATION_FAIL";

export const SET_DISPLAY_CHAT = "SET_DISPLAY_CHAT";

export const SET_CONVERSATIONS = "SET_CONVERSATIONS";
export const SET_SELECTED_CONVERSATION = "SET_SELECTED_CONVERSATION";

export const SET_DISPLAY_CUSTOMER_DETAILS = "SET_DISPLAY_CUSTOMER_DETAILS";

export const REGISTER_START = "REGISTER_START";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";

export const LOGOUT_START = "LOGOUT_START";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAIL = "LOGOUT_FAIL";

export const SET_SELECTED_USER_CUSTOMERS = "SET_SELECTED_USER_CUSTOMERS";

export const SET_CONSTANT_CONVERSATION = "SET_CONSTANT_CONVERSATION";

export const UPDATE_USER_START = "UPDATE_USER_START";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL";

export const PATCH_USER_START = "PATCH_USER_START";
export const PATCH_USER_SUCCESS = "PATCH_USER_SUCCESS";
export const PATCH_USER_FAIL = "PATCH_USER_FAIL";

export const SHOW_FILE_UPLOAD = "SHOW_FILE_UPLOAD";

export const SET_USER_VERIFICATION = "SET_USER_VERIFICATION";

// Update conversations
export const UPDATE_CONVERSATIONS_START = "UPDATE_CONVERSATIONS_START";
export const UPDATE_CONVERSATIONS_SUCCESS = "UPDATE_CONVERSATIONS_SUCCESS";
export const UPDATE_CONVERSATIONS_FAIL = "UPDATE_CONVERSATIONS_FAIL";

// Mark customer messages as "Read"
export const MARK_CUSTOMER_MESSAGES_AS_READ = "MARK_CUSTOMER_MESSAGES_AS_READ";

// Get archived conversation
// export const ARCHIVED_CONVERSATIONS_START = "ARCHIVED_CONVERSATIONS_START";
export const ARCHIVED_CONVERSATIONS_SUCCESS = "ARCHIVED_CONVERSATIONS_SUCCESS";

export const ADD_CONVERSATION_SUCCESS = "ADD_CONVERSATION_SUCCESS";

// Update selected conversation
export const UPDATE_GROUP_SELECTED_CONVERSATION_MEMBERS =
  "UPDATE_GROUP_SELECTED_CONVERSATION_MEMBERS";
export const SELECTED_CONVERSATION_CHAT = "SELECTED_CONVERSATION_CHAT";

// Update conversation media/links/docs
export const UPDATE_CONVERSATION_MEDIA = "UPDATE_CONVERSATION_MEDIA";
export const UPDATE_CONVERSATION_DOCS = "UPDATE_CONVERSATION_DOCS";
export const UPDATE_CONVERSATION_LINKS = "UPDATE_CONVERSATION_LINKS";

// Get conversation media
export const GET_CONVERSATION_MEDIA_START = "GET_CONVERSATION_MEDIA_START";
export const GET_CONVERSATION_MEDIA_FAIL = "GET_CONVERSATION_MEDIA_FAIL";

export const SET_MESSAGE_ID = "SET_MESSAGE_ID";

export const SET_CONVERSATION_DATA = "SET_CONVERSATION_DATA";
